import { useAppComponents } from './useAppComponents';
export function useAppImage() {
    const { AppImage } = useAppComponents();
    return AppImage;
}
